import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { LayoutDashboard, Image, Users, Inbox, FileText, Settings, LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/admin", label: "Tableau de bord", icon: LayoutDashboard, end: true },
  { to: "/admin/leads", label: "Demandes / Leads", icon: Inbox },
  { to: "/admin/portfolio", label: "Portfolio", icon: Image },
  { to: "/admin/logos", label: "Logos clients", icon: Users },
  { to: "/admin/blog", label: "Blog", icon: FileText },
  { to: "/admin/settings", label: "Paramètres", icon: Settings },
];

export default function AdminLayout() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-[#09090B] text-white flex">
      <aside className="w-64 shrink-0 border-r border-white/10 bg-zinc-950 flex flex-col fixed h-screen">
        <div className="px-6 py-6 border-b border-white/10">
          <div className="font-display font-extrabold text-lg tracking-tight">
            BLACK LEMON <span className="text-yellow-400">STUDIO</span>
          </div>
          <div className="text-xs text-zinc-500 mt-1">Back-office</div>
        </div>
        <nav className="flex-1 p-4 space-y-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`admin-nav-${n.label.split(" ")[0].toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  isActive ? "bg-yellow-400 text-black" : "text-zinc-400 hover:text-white hover:bg-white/5"
                }`
              }
            >
              <n.icon className="w-4 h-4" /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10 space-y-1">
          <Link to="/" target="_blank" className="flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm text-zinc-400 hover:text-white hover:bg-white/5">
            <ExternalLink className="w-4 h-4" /> Voir le site
          </Link>
          <button data-testid="admin-logout" onClick={doLogout} className="w-full flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm text-zinc-400 hover:text-white hover:bg-white/5">
            <LogOut className="w-4 h-4" /> Déconnexion
          </button>
        </div>
      </aside>
      <main className="flex-1 ml-64 p-8 lg:p-10">
        <Outlet />
      </main>
    </div>
  );
}
